"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _creative = require("../../constants/creative");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentTransform = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentTransform, _WireObject);

  var _super = _createSuper(CreativeDocumentTransform);

  function CreativeDocumentTransform() {
    var _this;

    (0, _classCallCheck2["default"])(this, CreativeDocumentTransform);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_alpha", _creative.DEFAULT_KEYFRAME_TRANSFORM.alpha);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_easingFunction", _creative.DEFAULT_KEYFRAME_TRANSFORM.easingFunction);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_filters", (0, _deepCopy["default"])(_creative.DEFAULT_KEYFRAME_TRANSFORM.filters));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rotation", _creative.DEFAULT_KEYFRAME_TRANSFORM.rotation);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scale", (0, _deepCopy["default"])(_creative.DEFAULT_KEYFRAME_TRANSFORM.scale));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setId", _creative.DEFAULT_KEYFRAME_TRANSFORM.setId);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setOrder", _creative.DEFAULT_KEYFRAME_TRANSFORM.setOrder);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_translation", (0, _deepCopy["default"])(_creative.DEFAULT_KEYFRAME_TRANSFORM.translation));
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentTransform, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentTransform.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var transform = {};
      transform.alpha = this.alpha;
      transform.easingFunction = this.easingFunction;
      transform.filters = this.filters;
      transform.rotation = this.rotation;
      transform.scale = this.scale;
      transform.setId = this.setId;
      transform.setOrder = this.setOrder;
      transform.translation = this.translation;
      return (0, _removeUnusedKeys["default"])(transform);
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    },
    set: function set(value) {
      if ((0, _isNumber["default"])(value) && value >= 0 && value <= 1) {
        this._alpha = value;
      }
    }
  }, {
    key: "easingFunction",
    get: function get() {
      return this._easingFunction;
    },
    set: function set(value) {
      if (_creative.VALID_EASING_FUNCTIONS.has(value)) {
        this._easingFunction = value;
      }
    }
  }, {
    key: "filters",
    get: function get() {
      return this._filters;
    },
    set: function set(value) {
      if (!(0, _isEmpty["default"])(value)) {
        this._filters = value;
      }
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    },
    set: function set(value) {
      if ((0, _isNumber["default"])(value)) {
        this._rotation = value;
      }
    }
  }, {
    key: "scale",
    get: function get() {
      return this._scale;
    },
    set: function set(value) {
      if (!(0, _isEmpty["default"])(value) && (0, _isNumber["default"])(value.x) && (0, _isNumber["default"])(value.y)) {
        this._scale = value;
      }
    }
  }, {
    key: "setId",
    get: function get() {
      return this._setId;
    },
    set: function set(value) {
      this._setId = value;
    }
  }, {
    key: "setOrder",
    get: function get() {
      return this._setOrder;
    },
    set: function set(value) {
      this._setOrder = value;
    }
  }, {
    key: "translation",
    get: function get() {
      return this._translation;
    },
    set: function set(value) {
      if (!(0, _isEmpty["default"])(value) && (0, _isNumber["default"])(value.x) && (0, _isNumber["default"])(value.y)) {
        this._translation = value;
      }
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inTransform) {
      if ((0, _isNil["default"])(inTransform)) return inTransform;
      var creativeDocumentTransform = new CreativeDocumentTransform();
      creativeDocumentTransform.alpha = inTransform.alpha;
      creativeDocumentTransform.easingFunction = inTransform.easingFunction;
      creativeDocumentTransform.filters = (0, _deepCopy["default"])(inTransform.filters);
      creativeDocumentTransform.rotation = inTransform.rotation;
      creativeDocumentTransform.scale = (0, _deepCopy["default"])(inTransform.scale);
      creativeDocumentTransform.setId = inTransform.setId;
      creativeDocumentTransform.setOrder = inTransform.setOrder;
      creativeDocumentTransform.translation = (0, _deepCopy["default"])(inTransform.translation);
      return creativeDocumentTransform;
    }
    /**
     * Checks if object is an instance of CreativeDocumentTransform
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isCreativeDocumentTransform",
    value: function isCreativeDocumentTransform(inputObject) {
      return inputObject instanceof CreativeDocumentTransform;
    }
  }]);
  return CreativeDocumentTransform;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentTransform;